import Vue from 'vue'
import {
  Toast,
  Lazyload,
  Image as VanImage,
  Tag,
  Tab,
  Tabs,
  Popup,
  Cell,
  CellGroup,
  Button,
  Icon,
  ActionSheet,
  Empty,
  ImagePreview,
  Field,
  Badge,
  Skeleton,
  Dialog,
  List
} from 'vant'

Vue.use(List)
Vue.use(Dialog)
Vue.use(Skeleton)
Vue.use(Badge)
Vue.use(Field)
Vue.use(Empty)
Vue.use(ActionSheet)
Vue.use(Icon)
Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Popup)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Tag)
Vue.use(VanImage)
Vue.use(Lazyload)
Vue.use(Toast)
Vue.prototype.ImagePreview = ImagePreview
